<template>
  <context-menu>
    <div class="d-flex flex-column pa-2">
      <e-btn
        size="M"
        variant="context"
        :prepend-icon-src="!isOperationHidden ? 'editPen' : 'clipboardList'"
        prepend-icon-size="20"
        @click="emit('edit')"
      >
        <span v-if="!isOperationHidden(props.editOperationStatus)">Редактировать</span>
        <span v-else>Просмотреть</span>
      </e-btn>
      <e-btn
        v-if="!isOperationHidden(props.deleteOperationStatus)"
        class="justify-start text-red"
        size="M"
        variant="context"
        prepend-icon-src="trash"
        prepend-icon-size="20"
        :disabled="isOperationDisabled(props.deleteOperationStatus)"
        @click="emit('remove')"
      >
        Удалить
      </e-btn>
    </div>
  </context-menu>
</template>

<script setup lang="ts">
import ContextMenu from '@/core/components/common/ContextMenu.vue';
import { EBtn } from '@/core/components/ui';
import { isOperationDisabled, isOperationHidden } from '@/core/utils/permissions';
import { OperationStatus } from '@/graphql/generated';

const props = defineProps<{
  deleteOperationStatus?: OperationStatus;
  editOperationStatus?: OperationStatus;
}>();

const emit = defineEmits<{
  (event: 'edit'): void;
  (event: 'remove'): void;
}>();
</script>
